import { z } from 'zod/v4';

import { columns } from './columns';

export const userSettingsSchema = z.object(columns);

export type UserSettings = z.output<typeof userSettingsSchema>;
